export default __webpack_public_path__ + "static/hexsound-68b6e1e1d5aef903a05154cf12372793.mp3";